import React from 'react'

/**
 * Wordmark "ΛXIOMΛ" dibujado en SVG (letras geométricas de trazo, la A sin
 * barra) para que se vea nítido a cualquier tamaño. Hereda el color con
 * `currentColor`.
 */
const AxiomaLogo = ({ height = 22, className }) => (
  <svg
    viewBox="-3 -3 310 37"
    height={height}
    fill="none"
    stroke="currentColor"
    strokeWidth="4.2"
    className={className}
    role="img"
    aria-label="Axioma"
  >
    <polyline points="0,31 21,0 42,31" />
    <path d="M58,0 L94,31 M94,0 L58,31" />
    <path d="M111,0 V31" />
    <rect x="128" y="0" width="54" height="31" rx="9" />
    <polyline points="199,31 199,0 222,21 245,0 245,31" />
    <polyline points="262,31 283,0 304,31" />
  </svg>
)

export default AxiomaLogo
